import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=12dfc906&"
import script from "./GeneralSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports